import React from 'react';

import './contact-form.css';

const ContactForm = (props) => {
  const handleSubmit = async (e) => {
    e.preventDefault();

    const form = e.target;
    const data = {
      name: form['form-name'].value,
      email: form['form-email'].value,
      message: form['form-message'].value,
    };

    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/contacts`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ data }),
      });

      if (res.ok) {
        alert('Danke, Nachricht gesendet!');
        form.reset();
      } else {
        alert('Fehler beim Senden');
      }
    } catch (err) {
      console.error(err);
      alert('Fehler beim Senden');
    }
  };

  return (
    <div className="contact-form-container thq-section-padding">
      <div className="contact-form-thq-max-width-elm thq-section-max-width">
        <div className="contact-form-thq-content-elm thq-flex-column">
          <form
            data-form-id="74573412-e983-42f8-9054-090172664099"
            className="contact-form-thq-email-form-container-elm"
            onSubmit={handleSubmit}
          >
            <div className="form-group">
              <label htmlFor="form-name" className="form-label">
                Name
              </label>
              <input
                type="text"
                id="form-name"
                name="form-name"
                required
                placeholder="Ihr Name"
                data-form-field-id="form-name"
                className="input form-input"
              />
            </div>
            <div className="form-group">
              <label htmlFor="form-email" className="form-label">
                Email
              </label>
              <input
                type="email"
                id="form-email"
                name="form-email"
                required
                placeholder="ihre@email.de"
                data-form-field-id="form-email"
                className="input form-input"
              />
            </div>
            <div className="form-group">
              <label htmlFor="form-message" className="form-label">
                Nachricht
              </label>
              <textarea
                id="form-message"
                name="form-message"
                rows="5"
                required
                placeholder="Ihre Nachricht..."
                data-form-field-id="form-message"
                className="textarea form-textarea"
              ></textarea>
            </div>
            <button
              id="thq_button_cWj4"
              name="button"
              type="submit"
              data-form-field-id="thq_button_cWj4"
              className="btn button btn-primary"
            >
              Senden
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactForm;
